import { FC } from 'react'

const TotalJobDisclaimer: FC<{ className: string }> = ({ className }) => (
  <div className={className}>
    In order to submit this application, a TotalJobs account will be created for you. As such, in addition to applying
    for this job, you will be signed up to all TotalJobs’ services as part of the process. By submitting this
    application, you agree to TotalJobs’{' '}
    <a href="https://www.totaljobs.com/about/terms-and-conditions" target="_blank">
      Terms and Conditions
    </a>{' '}
    and acknowledge that your personal data will be transferred to TotalJobs and processed by them in accordance with
    their{' '}
    <a href="https://www.totaljobs.com/about/privacy-policy" target="_blank">
      Privacy Policy.
    </a>
  </div>
)

export default TotalJobDisclaimer
